import { isUserLoggedIn } from '_services/LocalStorage/LoggedIn';
import { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

/**
 * Component responsible for checking if user is guest:
 *  - redirecting to homepage if user is not guest,
 *  - returning Outlet (aka child components), if user is guest
 */
const PrivateWrapper = (): ReactElement => {
    if (!isUserLoggedIn()) {
        const path = window.location.pathname;
        const search = window.location.search;
        let navigateTo = '/landing';

        if (path !== '/') {
            navigateTo = `/auth?lastLocation=${path}`;
        } else if (search) {
            navigateTo += search;
        }

        return <Navigate to={navigateTo} />;
    }

    return <Outlet />;
};

export default PrivateWrapper;
